import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AlertController } from "ionic-angular";
import { ApiService } from "../../services/api.service";

@Component({
  selector: 'page-change-password',
  templateUrl: 'change-password.html',
})
export class ChangePasswordPage {

  profileForm: FormGroup;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public alertCtrl: AlertController,
    public apiService: ApiService
  ) {
    this.profileForm = this.formBuilder.group({
      password: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
      password2: ['', Validators.compose([Validators.required, Validators.minLength(8)])]
    });
  }

  save(){
    let data = this.profileForm.value;
    if(data.password != data.password2){
      this.alertCtrl.create({
        title: 'Fout',
        message: 'De ingevulde wachtwoorden zijn niet hetzelfde.',
        buttons: ['OK']
      }).present();
    } else {
      this.apiService.setPassword(data.password).then(() => {
        this.alertCtrl.create({
          title: 'Wachtwoord gewijzigd',
          message: 'Uw nieuwe wachtwoord is opgeslagen.',
          buttons: [{
            text: 'OK',
            handler: () => {
              this.navCtrl.goToRoot({});
            }
          }]
        }).present();
      }).catch(() => {
        this.alertCtrl.create({
          title: 'Fout',
          message: 'Het wachtwoord kon niet opgeslagen worden.',
          buttons: ['OK']
        }).present();
      })
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChangePasswordPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/change-password/change-password.ts